var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardDocumentList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/clipboard-document-list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9999 15.9995H16.9999M11.9999 19.9995H16.9999M11.9999 23.9995H16.9999M20.9999 24.9995H23.9999C25.6567 24.9995 26.9999 23.6564 26.9999 21.9995V8.1438C26.9999 6.63049 25.8732 5.34638 24.3651 5.22121C23.8674 5.1799 23.3681 5.14429 22.8672 5.11443M15.1326 5.11443C15.0463 5.3942 14.9999 5.69143 14.9999 5.99951C14.9999 6.5518 15.4476 6.99951 15.9999 6.99951H21.9999C22.5522 6.99951 22.9999 6.5518 22.9999 5.99951C22.9999 5.69143 22.9534 5.3942 22.8672 5.11443M15.1326 5.11443C15.5102 3.8896 16.6511 2.99951 17.9999 2.99951H19.9999C21.3487 2.99951 22.4895 3.8896 22.8672 5.11443M15.1326 5.11443C14.6317 5.14429 14.1324 5.1799 13.6347 5.22121C12.1265 5.34638 10.9999 6.6305 10.9999 8.14381V10.9995M10.9999 10.9995H6.49988C5.67145 10.9995 4.99988 11.6711 4.99988 12.4995V27.4995C4.99988 28.3279 5.67145 28.9995 6.49988 28.9995H19.4999C20.3283 28.9995 20.9999 28.3279 20.9999 27.4995V12.4995C20.9999 11.6711 20.3283 10.9995 19.4999 10.9995H10.9999ZM8.99988 15.9995H9.00988V16.0095H8.99988V15.9995ZM8.99988 19.9995H9.00988V20.0095H8.99988V19.9995ZM8.99988 23.9995H9.00988V24.0095H8.99988V23.9995Z",
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardDocumentList);
export default __webpack_public_path__ + "static/media/clipboard-document-list.54067fca6040573e1f87ccfbb453ffe6.svg";
export { ForwardRef as ReactComponent };